export const ALLOWED_TAGS = ['b', 'p', 'i', 'u', 'ol', 'ul', 'a', 'li', 'strong', 'em', 'br']
export const ALLOWED_ATTR = ['href']
